/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_WhoInputs */

const en_mk_cmp_r_who = /** @type {(inputs: Mk_Cmp_R_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who it is for`)
};

const id_mk_cmp_r_who = /** @type {(inputs: Mk_Cmp_R_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk siapa`)
};

/**
* | output |
* | --- |
* | "Who it is for" |
*
* @param {Mk_Cmp_R_WhoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_who = /** @type {((inputs?: Mk_Cmp_R_WhoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_WhoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_who(inputs)
	return en_mk_cmp_r_who(inputs)
});